module.exports = __webpack_public_path__ + "static/gas_fees_bg@2x-ccbbcc05b4b1241de7652b27fed8652c.png";